module.exports = __webpack_public_path__ + "static/media/RP-60.77c249a5.pdf";